var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1985 6.44623C4.41844 6.22685 4.7745 6.22685 4.99444 6.44623L9 10.4569L13.0056 6.44623C13.2255 6.22685 13.5816 6.22685 13.8015 6.44623C14.0209 6.6656 14.0209 7.02563 13.8015 7.245L9.49444 11.5538C9.35944 11.6888 9.17494 11.7281 9 11.6944C8.82506 11.7281 8.64056 11.6888 8.50556 11.5538L4.1985 7.245C3.97913 7.02563 3.97913 6.6656 4.1985 6.44623ZM9 18C13.9703 18 18 13.9725 18 9C18 4.0275 13.9703 0 9 0C4.02975 0 0 4.0275 0 9C0 13.9725 4.02975 18 9 18Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownCircle);
export default __webpack_public_path__ + "static/media/ChevronDownCircle.23e632bc8c9e305309a287ece757379c.svg";
export { ForwardRef as ReactComponent };